module.exports = __webpack_public_path__ + "static/media/logo_t_marketing.482e372c.svg";